import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  slot: "end",
  class: "ion-text-center"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "header-title" }
const _hoisted_6 = { class: "main-title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  slot: "end",
  class: "ion-text-center"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "header-title" }
const _hoisted_11 = { class: "sub-title" }
const _hoisted_12 = { class: "sub-title" }
const _hoisted_13 = {
  slot: "end",
  class: "ion-text-center"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "header-title"
}
const _hoisted_16 = {
  key: 1,
  class: "header-title"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "header-title"
}
const _hoisted_19 = {
  key: 1,
  class: "header-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_chip = _resolveComponent("ion-chip")!

  return ($props.selectedView == 'home' || !$setup.user.id)
    ? (_openBlock(), _createBlock(_component_ion_header, {
        key: 0,
        style: {"background":"rgb(0, 80, 125)","box-shadow":"none"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--background":"transparent","--min-height":"122px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, {
                    slot: "start",
                    style: {"flex":"initial"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_logo_img, {
                        useWhiteLogo: true,
                        class: "big-logo"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        fill: "solid",
                        shape: "round",
                        color: "primary",
                        target: "_blank",
                        href: "https://www.instagram.com/jupas.scope"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.logoInstagram
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "solid",
                        shape: "round",
                        color: "primary",
                        target: "_blank",
                        href: "https://www.linkedin.com/company/fdmt"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.logoLinkedin
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "solid",
                        shape: "round",
                        color: "primary",
                        target: "_blank",
                        href: "https://www.youtube.com/user/FDMTvideo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.logoYoutube
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        size: "small",
                        class: "no-text-transform ion-no-margin",
                        href: "tel:+85224961533",
                        style: {"height":"48px","color":"#fff"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.callOutline
                          }, null, 8, ["icon"]),
                          _cache[3] || (_cache[3] = _createTextVNode(" +852 2496 1533")),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                          _cache[5] || (_cache[5] = _createTextVNode(" M-F 9:00-18:00")),
                          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
                        ]),
                        _: 1,
                        __: [3,4,5,6]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          })
        ]),
        _: 3
      }))
    : ($setup.user.isUniversityClient)
      ? (_openBlock(), _createBlock(_component_ion_header, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, {
              class: "ion-no-padding",
              fixed: "",
              style: _normalizeStyle({ 'background': !$setup.userRelatedClient?.bannerLink ? '#004976' : `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                                                                    url('${$setup.getProxyImgLink($setup.userRelatedClient?.bannerLink)}') center / cover no-repeat` })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, { style: {"padding":"0 8px","--background":"transparent","--min-height":"90px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_title, {
                      class: "ion-text-center",
                      style: {"padding":"0","color":"#fff"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_1, _toDisplayString($setup.userRelatedClient.department), 1),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sub-title" }, [
                              _createElementVNode("small", null, "powered by"),
                              _createTextVNode(" AchieveBot")
                            ], -1))
                          ]),
                          _: 1,
                          __: [7]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_toolbar, { style: {"padding":"0 8px 4px","--background":"transparent","--min-height":"28px"} }, {
                  default: _withCtx(() => [
                    ($props.showBackButton)
                      ? (_openBlock(), _createBlock(_component_ion_buttons, {
                          key: 0,
                          style: {"height":"24px"},
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_back_button, {
                              style: {"--color":"#fff"},
                              "default-href": "/home"
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_title, {
                      slot: "start",
                      class: "ion-no-padding",
                      style: {"flex":"initial"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_logo_img, { useWhiteLogo: true })
                      ]),
                      _: 1
                    }),
                    ($setup.userRelatedClient?.logoLink)
                      ? (_openBlock(), _createBlock(_component_ion_title, {
                          key: 1,
                          slot: "start",
                          class: "ion-no-padding",
                          style: {"flex":"initial"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              style: {"height":"30px","vertical-align":"bottom","margin-left":"5px"},
                              src: $setup.userRelatedClient?.logoLink
                            }, null, 8, _hoisted_2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      (!$props.hideUserProfileToolbar)
                        ? (_openBlock(), _createBlock(_component_ion_chip, {
                            key: 0,
                            "router-link": "/profile"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_avatar, { style: {"margin-right":"4px","height":"16px","width":"16px"} }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: $setup.getAppSheetFileLink('user', $setup.user.profilePic || 'https://ionicframework.com/docs/img/demos/avatar.svg')
                                  }, null, 8, _hoisted_4)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_5, _toDisplayString($setup.user.chineseName || $setup.user.preferredName || $setup.user.fullName || 'Profile'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _: 3
            }, 8, ["style"])
          ]),
          _: 3
        }))
      : ($setup.user.isUniversityStudent)
        ? (_openBlock(), _createBlock(_component_ion_header, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, {
                class: "ion-no-padding",
                fixed: "",
                style: _normalizeStyle({ 'background': !$setup.userRelatedJobEX?.bannerLink ? '#004976' : `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                                                                    url('${$setup.getProxyImgLink($setup.userRelatedJobEX?.bannerLink)}') center / cover no-repeat` })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, { style: {"padding":"0 8px","--background":"transparent","--min-height":"90px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, {
                        class: "ion-text-center",
                        style: {"padding":"0","color":"#fff"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_6, _toDisplayString($setup.userRelatedJobEX ? $setup.userRelatedJobEX['Department'] : 'jobEX'), 1),
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sub-title" }, [
                                _createElementVNode("small", null, "powered by"),
                                _createTextVNode(" AchieveBot")
                              ], -1))
                            ]),
                            _: 1,
                            __: [8]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_toolbar, { style: {"padding":"0 8px 4px","--background":"transparent","--min-height":"28px"} }, {
                    default: _withCtx(() => [
                      ($props.showBackButton)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 0,
                            style: {"height":"24px"},
                            slot: "start"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_back_button, {
                                style: {"--color":"#fff"},
                                "default-href": "/home"
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_title, {
                        slot: "start",
                        class: "ion-no-padding",
                        style: {"flex":"initial"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_logo_img, { useWhiteLogo: true })
                        ]),
                        _: 1
                      }),
                      ($setup.userRelatedJobEX && $setup.userRelatedJobEX.logoLink)
                        ? (_openBlock(), _createBlock(_component_ion_title, {
                            key: 1,
                            slot: "start",
                            class: "ion-no-padding",
                            style: {"flex":"initial"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                style: {"height":"30px","vertical-align":"bottom","margin-left":"5px"},
                                src: $setup.userRelatedJobEX.darkModeLogoLink || $setup.userRelatedJobEX.logoLink
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_8, [
                        (!$props.hideUserProfileToolbar)
                          ? (_openBlock(), _createBlock(_component_ion_chip, {
                              key: 0,
                              "router-link": "/profile"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_avatar, { style: {"margin-right":"4px","height":"16px","width":"16px"} }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: $setup.getAppSheetFileLink('user', $setup.user.profilePic || 'https://ionicframework.com/docs/img/demos/avatar.svg')
                                    }, null, 8, _hoisted_9)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString($setup.user.chineseName || $setup.user.preferredName || $setup.user.fullName || 'Profile'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        ($setup.user.waGroupLink)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              fill: "clear",
                              size: "small",
                              color: "success",
                              target: "_blank",
                              href: $setup.user.waGroupLink,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickWhatsAppButton())),
                              style: {"vertical-align":"middle","margin":"0","font-size":"11px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: $setup.logoWhatsapp
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["href"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _: 3
              }, 8, ["style"])
            ]),
            _: 3
          }))
        : (_openBlock(), _createBlock(_component_ion_header, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, {
                class: "ion-no-padding",
                fixed: "",
                style: _normalizeStyle({ 'background': `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                                                                    url('${$setup.getProxyImgLink($setup.userRelatedSchool?.bannerLink)}') center / cover no-repeat` })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, {
                    style: _normalizeStyle([{"padding":"0 8px","--background":"transparent"}, { '--min-height': $props.isAB3ParentView ? '60px' : '90px' }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, {
                        class: "ion-text-center",
                        style: {"padding":"0","color":"#fff"}
                      }, {
                        default: _withCtx(() => [
                          ($setup.user.isSecondaryStudent)
                            ? (_openBlock(), _createBlock(_component_ion_label, {
                                key: 0,
                                class: "ion-text-wrap"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_11, [
                                    _createElementVNode("b", null, _toDisplayString($setup.userRelatedSchool?.nameShort), 1)
                                  ]),
                                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sub-title" }, [
                                    _createElementVNode("small", null, "powered by"),
                                    _createTextVNode(" AchieveBot")
                                  ], -1))
                                ]),
                                _: 1,
                                __: [9,10]
                              }))
                            : (_openBlock(), _createBlock(_component_ion_label, {
                                key: 1,
                                class: "ion-text-wrap"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_12, [
                                    _createElementVNode("b", null, _toDisplayString($setup.userRelatedSchool?.nameShort), 1)
                                  ]),
                                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sub-title" }, [
                                    _createElementVNode("small", null, "powered by"),
                                    _createTextVNode(" AchieveBot")
                                  ], -1))
                                ]),
                                _: 1,
                                __: [11,12]
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["style"]),
                  _createVNode(_component_ion_toolbar, { style: {"padding":"0 8px 4px","--background":"transparent","--min-height":"28px"} }, {
                    default: _withCtx(() => [
                      ($props.showBackButton)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 0,
                            style: {"height":"24px"},
                            slot: "start"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_back_button, {
                                style: {"--color":"#fff"},
                                "default-href": "/home"
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_title, {
                        slot: "start",
                        class: "ion-no-padding",
                        style: {"flex":"initial"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_logo_img, { useWhiteLogo: true })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_13, [
                        ($props.isAB3ParentView)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_ion_chip, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      ($setup.user.class)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.user.class) + _toDisplayString($setup.formatStudentNumber($setup.user.studentNumber)) + " " + _toDisplayString($setup.user.chineseName || $setup.user.fullName), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.user.chineseName || $setup.user.preferredName || $setup.user.fullName || 'Student'), 1))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                class: "ion-no-margin",
                                color: "light",
                                size: "small",
                                fill: "clear",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openImageModal($setup.getProxyImgLink(`https://docs.google.com/presentation/d/1v8O0j-EYeGItQuS8N-lEj9qJQsV6oXOYtCG_y3x4F-U/export/jpeg?pageid=g2fa5c90539b_0_42`))))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: $setup.helpCircleOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (!$props.hideUserProfileToolbar)
                                ? (_openBlock(), _createBlock(_component_ion_chip, {
                                    key: 0,
                                    "router-link": "/profile"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          ($setup.user.isSecondaryStudent && $setup.user.class)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.user.class) + _toDisplayString($setup.formatStudentNumber($setup.user.studentNumber)), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($setup.user.chineseName || $setup.user.preferredName || $setup.user.fullName || 'Profile'), 1))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              ($setup.user.waGroupLink)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 1,
                                    fill: "clear",
                                    size: "small",
                                    color: "success",
                                    target: "_blank",
                                    href: $setup.user.waGroupLink,
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickWhatsAppButton())),
                                    style: {"vertical-align":"middle","margin":"0","font-size":"11px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: $setup.logoWhatsapp
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["href"]))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ]),
                    _: 1
                  }),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _: 3
              }, 8, ["style"])
            ]),
            _: 3
          }))
}